export const config = {
    title: "",
    description: "",
    showElapsedTime: true,
    showSportsNetWinnings: false,
    showCasinoNetWinnings: false,
    showSportsTurnover: false,
    showCasinoTurnover: false,
    intervalOptions: "5,10,15,30,60",
    showNoneOption: true,
    noneOptionText: "None",
    showWithDefaultInterval: false,
    defaultInterval: 1,
    buttonLink: "",
    showOnFirstLogin: false,
    closeByClickOnBackground: false
};
//# sourceMappingURL=config.js.map